import React, {useContext, useEffect} from 'react';
import {message} from 'antd';
import {useApolloClient} from 'react-apollo';
import {useHistory, useLocation} from 'react-router-dom';
import {OrgDataContext} from 'context/orgData';
import {ACTIVE_TRANSPORTER_PARAM, clearActiveTransporterParameter, SELECT_TRANSPORTER} from 'common/active-transporter';

/** Apply deep-link context only from the same contract-derived list used by the navbar. */
export default function ActiveTransporterFromQuery({children}: {children: React.ReactNode}) {
    const org = useContext(OrgDataContext);
    const client = useApolloClient();
    const history = useHistory();
    const {search} = useLocation();
    const requestedID = new URLSearchParams(search).get(ACTIVE_TRANSPORTER_PARAM);
    const allowed = org?.organization?.classType === 'flytsuite.customer'
        && org.tpList.some(transporter => transporter._id === requestedID);
    const currentID = org?.transporterID;
    const needsChange = !!requestedID && allowed && requestedID !== currentID;

    useEffect(() => {
        if (!requestedID || requestedID === currentID) return;

        if (!allowed) {
            message.warning('The requested transporter is not available to your organization.');
            clearActiveTransporterParameter(history);
            return;
        }

        client.mutate({mutation: SELECT_TRANSPORTER, variables: {id: requestedID}}).catch(() => {
            message.error('Unable to change the active transporter. Please select it in the navigation bar.');
            if (new URLSearchParams(history.location.search).get(ACTIVE_TRANSPORTER_PARAM) === requestedID) {
                clearActiveTransporterParameter(history);
            }
        });
    }, [requestedID, currentID, allowed, client, history]);

    // Do not let destination queries run with the previous transporter's context.
    return needsChange ? null : <>{children}</>;
}
